import { createContext, useEffect, useState } from "react";

const intialContextValues = {
  variants: [],
  loading: undefined,
  error: undefined,
  refetch: () => null,
};

const ProductsContext = createContext(intialContextValues);

const ProductsProvider = ({ children }) => {
  const [loading, setLoaidng] = useState(false);
  const [productVariantsOptions, setProductsVariantsOptions] = useState([]);

  useEffect(() => {
    const fetchProductsOptions = async () => {
      setLoaidng(true);
      const response = await fetch(`${process.env.REACT_APP_REST_API_ENDPOINT}/products/options`);
      const data = await response.json();
      console.log("Prepared products options via RESTful endpoint", data.length);
      setProductsVariantsOptions(data);
      setLoaidng(false);
    };

    fetchProductsOptions();
  }, []);

  return (
    <ProductsContext.Provider
      value={{
        variants: productVariantsOptions,
        loading: loading,
        error: null,
        refetch: null,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export { ProductsContext, ProductsProvider };
